export default "__VITE_ASSET__62f3a030__"